import initLayoutContainer from 'opentok-layout-js';
import classNames from 'classnames';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ChevronLeftLarge, ChevronRightLarge } from 'wix-ui-icons-common';
import { DH } from '../../../../data-hooks';
import { useGridLayout } from '../../../../hooks/grid-layout';
import { IconButton } from '../../../commons/icon-button';
import { useVideoConfig } from '../../video-config-provider';
import { Tile } from '../tile';
import s from './grid-layout.scss';
var ratios = [9 / 16, 10 / 16, 4 / 3, 1, 2, 3 / 2];
export var GridLayout = function (_a) {
    var _b;
    var width = _a.width, height = _a.height;
    var _c = useVideoConfig(), mobile = _c.mobile, webinar = _c.webinar, sidePanelOpened = _c.sidePanelOpened;
    var minRatio = ratios[0];
    var maxRatio = mobile ? ratios[5] : ratios[0];
    var _d = useState(0), currentPage = _d[0], setCurrentPage = _d[1];
    var _e = useGridLayout(currentPage), attendees = _e.attendees, visibleAttendeeIds = _e.visibleAttendeeIds, pagesCount = _e.pagesCount, focusedAttendeeId = _e.focusedAttendeeId;
    var content = useRef(null);
    var landscape = window.innerWidth > window.innerHeight;
    var layout = useMemo(function () {
        if (!content.current) {
            return null;
        }
        return initLayoutContainer(content.current, {
            maxRatio: maxRatio,
            minRatio: minRatio,
            fixedRatio: false,
            alignItems: 'center',
            ignoreClass: 'lv_ignored',
        }).layout;
    }, [content.current, visibleAttendeeIds]);
    useEffect(function () {
        layout && layout();
    }, [width, height, attendees, layout]);
    var setPreviousPage = function () { return (currentPage === 0 ? setCurrentPage(pagesCount - 1) : setCurrentPage(currentPage - 1)); };
    var setNextPage = function () { return (currentPage + 1 === pagesCount ? setCurrentPage(0) : setCurrentPage(currentPage + 1)); };
    return (React.createElement("div", { className: classNames(s.container, (_b = {},
            _b[s.mobile] = mobile,
            _b[s.sidePanelOpened] = sidePanelOpened,
            _b[s.landscape] = landscape,
            _b)) },
        React.createElement("div", { className: s.content, ref: content },
            pagesCount > 1 ? (React.createElement("div", { className: "lv_ignored" },
                React.createElement(IconButton, { dataHook: DH.PREV_PAGE, className: classNames(s.button, s.buttonLeft), Icon: ChevronLeftLarge, onClick: setPreviousPage }),
                React.createElement(IconButton, { dataHook: DH.NEXT_PAGE, className: classNames(s.button, s.buttonRight), Icon: ChevronRightLarge, onClick: setNextPage }))) : null,
            attendees.map(function (attendeeId) {
                var _a;
                var visible = visibleAttendeeIds.includes(attendeeId);
                if (!visible) {
                    return null;
                }
                return (React.createElement("div", { className: s.tile, key: attendeeId },
                    React.createElement(Tile, { className: classNames((_a = {}, _a[s.active] = !webinar && attendeeId === focusedAttendeeId, _a)), attendeeId: attendeeId })));
            }))));
};
//# sourceMappingURL=grid-layout.js.map